import { EmergencyNotificationAcknowledgment } from '@dreryk/egabinet-emergency-notification-frontend-api';

import { StrongText, Text, TextSeparator, TextSeparatorType } from '@dreryk/react-components';
import { hourMinuteFormatter } from '@dreryk/react-common';

import { PractitionerSafePresenter } from '~libs.desktop.shared.practitioner-safe-presenter';

type AcknowledgedByCellItemProps = {
   acknowledgment: EmergencyNotificationAcknowledgment;
};

export const AcknowledgedByCellItem = (props: AcknowledgedByCellItemProps): JSX.Element => {
   return (
      <TextSeparator separator={TextSeparatorType.COMMA_SPACE}>
         <StrongText testId={props.acknowledgment.id}>
            <PractitionerSafePresenter
               testId={'acknowledgedByPractitioner'}
               practitioner={props.acknowledgment}
               presentationOrder={'lastName'}
               withIdentification={false}
               type={'text'}
            />
         </StrongText>
         <Text testId={'acknowledgedAt'}>{hourMinuteFormatter(props.acknowledgment.acknowledgedAt)}</Text>
      </TextSeparator>
   );
};
